import {
  AdaptedFeaturesSettingsDTO,
  FeatureActionType,
  FeatureType,
} from '@/domain/settings/settingTypes'

const isActionRequired = (
  feature?: FeatureType,
  data_type?: FeatureActionType,
  remoteSettings?: AdaptedFeaturesSettingsDTO,
) => {
  if (!feature || !data_type || !remoteSettings) return true

  const filteredFeature = remoteSettings.features?.[feature]
  const actions = filteredFeature?.actions ?? []

  const action = actions.find((action) => action.data_type === data_type)

  if (action === null || action === undefined) return false

  return action?.required
}

export const resolveFeatureSettings = (
  feature?: FeatureType,
  remoteSettings?: AdaptedFeaturesSettingsDTO,
) => {
  const isPhoneRequired = isActionRequired(feature, 'phone', remoteSettings)
  const isEmailRequired = isActionRequired(feature, 'email', remoteSettings)
  const isKycRequired = isActionRequired(feature, 'kyc', remoteSettings)

  const kycRequiredAboveUSD =
    remoteSettings?.features?.[feature as FeatureType]?.extra_info
      ?.no_kyc_max_usd_amount

  return {
    isPhoneRequired,
    isEmailRequired,
    isKycRequired,
    kycRequiredAboveUSD,
  }
}
